export function getAuthorizationHeader() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token") ||""}`,
  };
}
